import axios from 'axios';
import endpoints from '@/api/endpoints';

export default {
  async getWOTypes () {
    return axios.get(endpoints.woTypes).then((response) => {
      return response.data;
    })
  }
}